export const SUBSCRIPTION_API_ROUTES = {
  GET_SUBSCRIPTION: "/admin/subscription",
  GET_SUBSCRIPTION_BY_ID: "/admin/subscription/:id",
  GET_SUBSCRIPTION_BY_USERID: '/admin/subscription/:id/details',
  CREATE_SUBSCRIPTION: "/admin/subscription",
  UPDATE_SUBSCRIPTION: "/admin/subscription/:id",
  UPDATE_USER_SUBSCRIPTION: "/admin/subscription/:id/details",
  DELETE_SUBSCRIPTION: "/admin/subscription/:id",
};
